import createReducer, { ActionCreatorHelper } from 'store/createReducer';

interface Phone {
    code: string;
    ext: string;
    tel: string;
}

export interface ClickmeConfig {
    email: string;
    fillBalancePopupMinValue: number;
    fillBalancePopupShowInterval: number;
    maxBannersInCampaign: number;
    minPaymentSum: number;
    phones: Phone[];
    phonesByCodes: Record<string, Phone>;
    webdavPublicUrl: string;
}

// ----------------------- actions -------------------------------------
const SET_CLICKME_CONFIG = 'SET_CLICKME_CONFIG';

interface PayloadTypes {
    [SET_CLICKME_CONFIG]: ClickmeConfig;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setClickmeConfig = ActionCreator(SET_CLICKME_CONFIG);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface ClickmeState {
    email: string;
    minPaymentSum: number;
    maxBannersInCampaign: number;
    phones: Record<string, Phone>;
    webdavPublicUrl: string;
}

export const CLICKME_INITIAL_STATE: ClickmeState = {
    email: '',
    minPaymentSum: 0,
    maxBannersInCampaign: 0,
    phones: {},
    webdavPublicUrl: '',
};

export default createReducer<ClickmeState, PayloadTypes>(CLICKME_INITIAL_STATE, {
    [SET_CLICKME_CONFIG]: (state, { payload }) => ({
        ...state,
        email: payload.email,
        minPaymentSum: payload.minPaymentSum,
        maxBannersInCampaign: payload.maxBannersInCampaign,
        phones: payload.phonesByCodes,
        webdavPublicUrl: payload.webdavPublicUrl,
    }),
});
// ----------------------- /reducer --------------------------------------
